module.exports = __webpack_public_path__ + "img/14.0d7f1a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/new_fair/14.png
// module id = 813
// module chunks = 1